import axios from "axios";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Spinner } from "react-bootstrap";

const BASE_API_URL = process.env.REACT_APP_API_URL;

const ValueFitQuestions = ({
  userId,
  companyName,
  resumeId,
  resumeName,
  onPrevious,
  onNext,
  score,
  setScore,
}) => {
  const [randomQuestions, setRandomQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  // const [score, setScore] = useState(0); // Holds the final count
  const [errorMessage, setErrorMessage] = useState("");

  console.log(userId);
  useEffect(() => {
    const fetchQuestions = async () => {
      if (!companyName) {
        setErrorMessage("Company name is required.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setErrorMessage("");

      try {
        const lowerCaseCompanyName = companyName.toLowerCase();
        const response = await axios.get(`${BASE_API_URL}/randomQuestions`, {
          params: { companyName: lowerCaseCompanyName, count: 10 },
        });
        setRandomQuestions(response.data || []);
      } catch (error) {
        console.error("Error fetching questions:", error);
        setErrorMessage("Failed to fetch questions. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuestions();
  }, [companyName]);

  const handleAnswerChange = (questionText, selectedAnswer) => {
    if (showResult) return; // Prevent changes after submitting

    setAnswers((prev) => {
      return {
        ...prev,
        [questionText]: selectedAnswer,
      };
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const userAnswers = randomQuestions.map((question) => ({
        question: question.question, // Send the question text
        selectedAnswer: answers[question.question], // Get the selected answer using question text as key
      }));

      // Logic to calculate the score
      let correctCount = 0;
      randomQuestions.forEach((q) => {
        const userSelectedAnswer = answers[q.question];
        const correctAnswer = q.correctOption;

        // Compare user's selected answer with the correct answer
        if (userSelectedAnswer === correctAnswer) {
          correctCount += 1; // Increment score if the answer is correct
        }
      });

      setScore(correctCount); // Set the final score
      setShowResult(true); // Show the results
    } catch (error) {
      console.error("Error submitting quiz:", error);
      setErrorMessage("Failed to calculate score.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">Value Fit Questions: {companyName}</h2>

      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

      <Card className="shadow-sm p-4">
        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading your quiz...</p>
          </div>
        ) : randomQuestions.length === 0 ? (
          <Alert variant="warning" className="text-center">
            <h5>Sorry 😔</h5>
            <p>
              We could not find questions for this company.
              <br />
              Please enter a <strong>genuine company name</strong> and try
              again.
            </p>
          </Alert>
        ) : (
          <div>
            {randomQuestions.map((q, index) => {
              const questionId = q._id || `q-${index}`;

              return (
                <div
                  key={questionId}
                  className="mb-4 p-3 border rounded bg-white"
                >
                  <p className="fw-bold">
                    Q{index + 1}: {q.question}
                  </p>

                  {q.options.map((option, i) => {
                    const isSelected = answers[q.question] === option;
                    const isCorrect = option === q.correctOption;

                    let labelClass = "form-check-label";
                    if (showResult) {
                      if (isCorrect) labelClass += " text-success fw-bold";
                      else if (isSelected) labelClass += " text-danger";
                    }

                    return (
                      <div
                        key={`${questionId}-opt-${i}`}
                        className="form-check mb-2"
                      >
                        <input
                          type="radio"
                          name={`radio-group-${questionId}`}
                          id={`input-${questionId}-${i}`}
                          value={option}
                          checked={isSelected}
                          disabled={showResult}
                          onChange={() =>
                            handleAnswerChange(q.question, option)
                          }
                          className="form-check-input"
                        />
                        <label
                          htmlFor={`input-${questionId}-${i}`}
                          className={labelClass}
                        >
                          {option}
                          {showResult && isCorrect && " ✓"}
                          {showResult && isSelected && !isCorrect && " ✗"}
                        </label>
                      </div>
                    );
                  })}
                </div>
              );
            })}

            {!showResult && (
              <Button
                variant="success"
                className="w-100 mt-3"
                onClick={handleSubmit}
                disabled={Object.keys(answers).length < randomQuestions.length}
              >
                Submit and Calculate Score
              </Button>
            )}
          </div>
        )}
      </Card>

      {showResult && (
        <Alert variant="info" className="mt-4 text-center">
          <h3>
            Your Final Score: {score} / {randomQuestions.length}
          </h3>
        </Alert>
      )}

      <div className="mt-4 d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onPrevious}>
          Previous
        </Button>
        <Button
          variant="primary"
          onClick={() => onNext({ answers, score })}
          disabled={!showResult || randomQuestions.length === 0}
        >
          Proceed to Next Phase
        </Button>
      </div>
    </div>
  );
};

export default ValueFitQuestions;
